export enum LocalStorageEnum {
  token = '_t',
  refresh_token = '_rft',
  permissions = '_perm',
  role = '_r',
  language = '_lang',
  required_change_password = '_rcp',
  otp_token = '_otp_t',
}
